import React from 'react';
import sendToast from './index';

const FavoriteToastMessage: React.FC<{ pageName: string }> = ({ pageName }) => (
    <>
        <span className="app-toast-title">{pageName} is now your favorite page</span>
        <span className="app-toast-sub">It will open by default when you sign in.</span>
    </>
);

const showFavoritePageToast = (pageName: string) => {
    sendToast('success', <FavoriteToastMessage pageName={pageName} />, {
        className: 'app-toast--favorite',
    });
};

export default showFavoritePageToast;
